export default {
  state: {
    apiData: {},      // 公共请求的数据
    timingApi: {},    // 这是时间限制的Api
    apiList: []      // 已经请求到的api数组
  },
  mutations: {
    set_apiData (state, val) {
      state.apiData = val
    }
  },
  actions: {
    async getApiData (context, val) {
      console.log(val)
      let { commit } = context
      let { state } = context
      console.log(commit, state)
      // setTimeout(() => {
      //   commit('set_apiData', '完美啊，大兄弟')
      // }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api.js